@if (visible()) {
  <div class="subbar hub-anim" data-subbar>
    <div class="subbar__fila">
      <div class="subbar__ruta">
        @if (hayAtras()) {
          <button class="subbar__atras" type="button" (click)="atras()" [attr.aria-label]="nombreAccesibleAtras()" [attr.title]="etiquetaAtras()" data-atras>
            <span class="pi pi-arrow-left" aria-hidden="true"></span>
            <span class="subbar__atras-txt">{{ textoAtras() }}</span>
          </button>
        }

        <nav class="subbar__migas" aria-label="Ruta de navegación">
          <ol>
            @for (m of tramosAnteriores(); track $index) {
              <li class="subbar__tramo">
                @if (m.url) { <a [routerLink]="m.url">{{ m.etiqueta }}</a> } @else { <span>{{ m.etiqueta }}</span> }
                <span class="pi pi-angle-right subbar__sep" aria-hidden="true"></span>
              </li>
            }
            <li class="subbar__tramo subbar__tramo--actual" aria-current="page">
              <span class="pi subbar__ico" [class]="icono()" aria-hidden="true"></span>
              <span class="subbar__titulo">{{ titulo() }}</span>
            </li>
          </ol>
        </nav>
      </div>

      @if (muestraSelector()) {
        <div class="subbar__obra"><app-selector-obra /></div>
      }
    </div>
  </div>
}
